// PLAZO CON UNIDAD (Mario, 23-oct; PLZ-01..04): cada plazo es en días (sin unidad = días, lo de siempre) o en horas
// (en cobranza vence a la hora exacta del cobro + N horas; desde el 26-oct también en cesión de deuda, TRF-10). Lo mismo que el núcleo en
// modules/liquidacion/dominio/tarifario.js. Sin tipos complejos: test/plazo-unidad.test.mjs lo carga sin typescript.

export const plazoDe = (r: any) => {
  const unidad = (r && r.unit) || 'DIAS';
  return { unidad, valor: unidad === 'HORAS' ? r.hours : r && r.days };
};

export const nombreDelPlazo = (p: any) => {
  const n = Number(p && p.valor);
  if (p && p.unidad === 'HORAS') return n === 1 ? '1 hora' : `${n} horas`;
  return n === 1 ? '1 día' : `${n} días`;
};

/** La llave de un plazo para elegirlo en una lista: «HORAS:24», «DIAS:1». */
export const claveDelPlazo = (r: any) => {
  const p = plazoDe(r);
  return `${p.unidad}:${p.valor}`;
};

/** Lo que se manda al núcleo: en horas, `hours` y `days` como redondeo hacia arriba; en días, solo `days`. */
export const conUnidad = (unidad: string, valor: any) => {
  const n = Number(valor);
  return unidad === 'HORAS' ? { unit: 'HORAS', hours: n, days: Math.ceil(n / 24) } : { unit: 'DIAS', days: n };
};

/** Error del plazo, o '' si está bien: entero desde 1. Antes: en cesión de deuda, solo días. */
export const errorDelPlazo = (unidad: string, valor: any, modelo: string) => {
  const n = Number(valor);
  if (valor === null || valor === undefined || valor === '' || !Number.isInteger(n) || n < 1) {
    return unidad === 'HORAS' ? 'Las horas del plazo deben ser un entero desde 1' : 'Los días del plazo deben ser un entero desde 1';
  }
  return '';
};

// TRF-10 (Mario, 26-oct): el mismo plazo puede repetirse con nombre distinto (Aliado preferencial / Aliado general).
const nombreClave = (l: any) => String(l || '').trim().toLowerCase();

/** La llave de una fila de la tabla: plazo y nombre («HORAS:24:aliado general»). */
export const claveDeFila = (r: any) => `${claveDelPlazo(r)}:${nombreClave(r && r.label)}`;

/** La fila de la tabla de ese plazo; si hay varias, la de ese nombre (como el núcleo). */
export const filaDeLaTabla = (rows: any, plazo: any) => {
  const clave = claveDelPlazo(plazo);
  const filas = (rows || []).filter((r: any) => claveDelPlazo(r) === clave);
  if (filas.length <= 1) return filas[0] || null;
  return filas.find((r: any) => nombreClave(r.label) === nombreClave(plazo && plazo.label)) || null;
};

/**
 * La comisión de la fila: SOLO el descuento, a 2 decimales; null si falta una parte del desglose. El uso de plataforma es
 * otro concepto, un cargo aparte, y no se suma (TRF-12, Mario 26-oct noche). Antes: descuento + plataforma.
 */
export const comisionDeFila = (r: any) => {
  const vacio = (x: any) => x === null || x === undefined || x === '';
  if (!r || vacio(r.discount_value) || vacio(r.platform_value)) return null;
  return Math.round(Number(r.discount_value) * 100 + 1e-9) / 100;
};
